var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "harness" }, [
    _c("div", { staticClass: "harness-bar" }, [
      _c("strong", [_vm._v("Vue 2 form branding harness")]),
      _c("label", [
        _vm._v("Brand source "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mode,
                expression: "mode"
              }
            ],
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.mode = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "own" } }, [_vm._v("Form kit")]),
            _c("option", { attrs: { value: "scheduler" } }, [
              _vm._v("Scheduler kit")
            ]),
            _c("option", { attrs: { value: "legacy" } }, [_vm._v("Legacy")])
          ]
        )
      ]),
      _c("label", [
        _vm._v("Appearance "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.appearance,
                expression: "appearance"
              }
            ],
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.appearance = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "legacy" } }, [_vm._v("Legacy")]),
            _c("option", { attrs: { value: "light" } }, [_vm._v("Light")]),
            _c("option", { attrs: { value: "dark" } }, [_vm._v("Dark")]),
            _c("option", { attrs: { value: "both" } }, [_vm._v("Both")])
          ]
        )
      ]),
      _c("label", [
        _vm._v("Choices "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ownBranding.choices.presentation,
                expression: "ownBranding.choices.presentation"
              }
            ],
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.ownBranding.choices,
                  "presentation",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "list" } }, [_vm._v("List")]),
            _c("option", { attrs: { value: "cards" } }, [_vm._v("Cards")]),
            _c("option", { attrs: { value: "pills" } }, [_vm._v("Pills")])
          ]
        )
      ]),
      _c("label", [
        _vm._v("Layout "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.ownBranding.choices.layout,
                expression: "ownBranding.choices.layout"
              }
            ],
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.$set(
                  _vm.ownBranding.choices,
                  "layout",
                  $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                )
              }
            }
          },
          [
            _c("option", { attrs: { value: "vertical" } }, [
              _vm._v("Vertical")
            ]),
            _c("option", { attrs: { value: "inline" } }, [_vm._v("Inline")]),
            _c("option", { attrs: { value: "columns" } }, [_vm._v("Columns")])
          ]
        )
      ]),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.complete,
              expression: "complete"
            }
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.complete)
              ? _vm._i(_vm.complete, null) > -1
              : _vm.complete
          },
          on: {
            change: function($event) {
              var $$a = _vm.complete,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.complete = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.complete = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.complete = $$c
              }
            }
          }
        }),
        _vm._v(" Confirmation")
      ]),
      _c("label", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inFrame,
              expression: "inFrame"
            }
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.inFrame)
              ? _vm._i(_vm.inFrame, null) > -1
              : _vm.inFrame
          },
          on: {
            change: function($event) {
              var $$a = _vm.inFrame,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.inFrame = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.inFrame = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.inFrame = $$c
              }
            }
          }
        }),
        _vm._v(" Iframe spacing")
      ]),
      _c("span", [_vm._v("Local emits: " + _vm._s(_vm.completionCount))])
    ]),
    _c(
      "main",
      { staticClass: "harness-stage" },
      [
        _c("form-v2", {
          key:
            _vm.mode +
            "-" +
            _vm.appearance +
            "-" +
            _vm.inFrame +
            "-" +
            _vm.ownBranding.choices.presentation +
            "-" +
            _vm.ownBranding.choices.layout,
          attrs: {
            form: _vm.activeForm,
            font: _vm.activeForm.font,
            complete: _vm.complete,
            "in-frame": _vm.inFrame,
            "disable-partial-data": true
          },
          on: { complete: _vm.onComplete }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }